import { ProductPropsGenqlSelection } from "@/gql/gen";

export const ProductPropsFields: ProductPropsGenqlSelection = {
    SALE_SPECIAL: true,
    KKAL: true,
    BELKI: true,
    ZHIRY: true,
    UGLEVODY: true,
    WEIGHT: true,
    FLAGS: true,
    MODIFICATORS: true,
    SET_ITEMS: {
        PRODUCT_ID: true,
        QUANTITY: true,
        UID: true
    },
}
